import {Component, Input} from '@angular/core';
import {ImageService} from '../../service/ImageService';
import {Artist} from '../../model/Artist';
import {AlbumSummary} from '../../model/AlbumSummary';
import { AlbumSummaryCollection } from 'src/app/model/AlbumSummaryCollection';

@Component({
  selector: 'app-albums-table',
  templateUrl: './albums-table.component.html',
  styleUrls: ['./albums-table.component.scss']
})
export class AlbumsTableComponent {

  @Input()
  artist: Artist;

  @Input()
  albums: AlbumSummaryCollection;

  constructor(
    private imageService: ImageService
  ) {
  }

  getAlbumCoverImg(artistId: string, albumId: string): string {
    return this.imageService.getSmallAlbumCoverImg(artistId, albumId);
  }

}
